import React, {Children, Component} from 'react';
import styles from './styles.css';

export default class CheckBoxGroup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			is_folded: true,
		};
	}

	render() {
		const {
			children,
			className,
			elementClassName,
			isSlim,
			limit,
			with_control,
			onToggleAllClick,
			...props
		} = this.props;

		const {is_folded} = this.state;

		const classes = [];
		classes.push(styles['check-box-group']);

		if (className) {
			classes.push(className);
		}

		if (isSlim) {
			classes.push(styles['check-box-group_slim']);
		}

		let shown_items = [];
		let folded_items = [];
		let has_folded_items = false;


		const li_classes = [styles['check-box-group__item']];
		if (elementClassName) {
			li_classes.push(elementClassName);
		}
		const li_class = li_classes.join(' ');

		if (limit && limit > 0)
		{
			Children.toArray(children).forEach((item, index) => {
				const li_item = (<li className={li_class} key={item.key}>{item}</li>);
				if (index < limit)
				{
					shown_items.push(li_item)
				}
				else
				{
					has_folded_items = true;
					if (is_folded)
					{
						return false;
					}
					folded_items.push(li_item)
				}
			});

			if (has_folded_items)
			{
				if (is_folded)
				{
					folded_items.push(<li key={'unfold'} className={styles['check-box-group__fold_pseudo']} onClick={::this.onFoldToggleClick}>Показать все</li>);
				}
				else
				{
					if (folded_items.length > 10)
					{
						shown_items.unshift(<li key={'fold_top'} className={styles['check-box-group__fold_pseudo']} onClick={::this.onFoldToggleClick}>Свернуть</li>);
					}
					folded_items.push(<li key={'fold_bottom'} className={styles['check-box-group__fold_pseudo']} onClick={::this.onFoldToggleClick}>Свернуть</li>);
				}
			}
		}
		else
		{
			shown_items = Children.toArray(children).map((item) => (
				<li className={li_class} key={item.key}>
					{item}
				</li>
			));
		}




		if (with_control && onToggleAllClick)
		{
			return (
				<div className={styles.wrapper}>
					<span>
						<a href="#"
							onClick={e => {e.preventDefault(); onToggleAllClick(true)}}
						>
							Выбрать все
						</a>
						<a href="#"
							onClick={e => {e.preventDefault(); onToggleAllClick(false)}}
							className={styles.uncheck_all_link}
						>
							Снять отметку со всех
						</a>
					</span>
					<ul className={classes.join(' ')} {...props}>
						{shown_items}
						{folded_items}
					</ul>
				</div>
			);
		}
		else
		{
			return (
				<ul className={classes.join(' ')} {...props}>
					{shown_items}
					{folded_items}
				</ul>
			);
		}
	}

	onFoldToggleClick() {
		const {is_folded} = this.state;

		this.setState({
			'is_folded': !is_folded,
		});
	}
}